module.exports = __webpack_public_path__ + "img/solution.cf77720d.png";